// @flow
import DataUtils from 'common/utils/DataUtils';
import EntityImportDataHelper from 'common/entity/helpers/EntityImportDataHelper';
import I18nHelper from 'common/helpers/I18nHelper';
import { PhoneNumber } from 'common/models/internal/PhoneNumber';
import * as Immutable from 'immutable';
import CountryHelper from 'common/helpers/CountryHelper';
import { MasterTransporter } from 'common/models/internal/MasterTransporter';
import { EntityImportHelper } from 'common/entity/helpers/EntityImportHelper';

const translationsNamespace = ['entityManagement'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

export class TransporterImportHelper extends EntityImportDataHelper {
    static validateEmailAddress({ entity }) {
        const emailAddress = entity.getIn(['emailAddress', 'emailAddress']);
        return super.validateEmailAddress(emailAddress);
    }
    static processAdditionalPhoneNumbers({ cellValue }) {
        return cellValue
            ? [
                  {
                      phoneNumber: cellValue.trim()
                  }
              ]
            : [];
    }
    static validateCountryCode({ entity }) {
        const { address } = entity;
        const { countryCode } = address;
        if (DataUtils.isEmpty(countryCode)) {
            return nsTranslate('validations:emptyCountryCode');
        } else if (
            !DataUtils.isEmpty(countryCode) &&
            !CountryHelper.isValid(countryCode)
        ) {
            return nsTranslate('validations:invalidCountryCode');
        }
    }

    static serializeAdditionalPhoneNumbers = (
        additionalPhoneNumbers: Array<{ phoneNumber: string }>
    ): Immutable.List<PhoneNumber> =>
        Immutable.List(additionalPhoneNumbers).map(item =>
            PhoneNumber.fromJS(item)
        );

    static processEntityRows = ({ rows }, { clientId }) => {
        return rows.map(entityRow =>
            entityRow.map((cellValue, headerId) => {
                switch (headerId) {
                    case 'customProperties':
                        return cellValue.filter(value => value);
                    case 'contactId':
                        return cellValue &&
                            !DataUtils.isEmpty(cellValue.get('contactId'))
                            ? cellValue.set('clientId', clientId)
                            : null;
                    default:
                        return cellValue;
                }
            })
        );
    };

    static getUploadedEntities = ({
        uploadedTable,
        clientId,
        getDataForCell
    }) => {
        const transportersData = EntityImportHelper.makeDataForEntities({
            table: uploadedTable,
            clientId,
            getDataForCell,
            processEntityRows: TransporterImportHelper.processEntityRows
        });
        const transporterEntities = Immutable.List(
            transportersData.map(transporterEntity => {
                const entity = MasterTransporter.fromJS(
                    transporterEntity.toJS()
                );
                const contactId = entity.contactId;
                const updatedEntity =
                    !contactId?.clientId && contactId?.contactId
                        ? entity.setContactId(
                              entity.contactId.setClientId(entity.clientId)
                          )
                        : entity;
                return updatedEntity;
            })
        );

        return transporterEntities;
    };

    static getCustomFields(entitySettings) {
        return entitySettings?.transporterSettings?.customFields;
    }

    static generateEntityList = (
        transporterData: Array<*>
    ): Immutable.List<MasterLocation> =>
        Immutable.List(
            transporterData.map(transporterEntity =>
                MasterTransporter.fromJS(transporterEntity)
            )
        );
}

export default TransporterImportHelper;
